import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { Pagination } from '../../../model/paginatiion';
import { IPurchaseContractResponse } from '../../../model/base/response/purchase-contract-response';

interface PurchaseContractsState {
  contracts: Pagination<IPurchaseContractResponse>;
  loading: boolean;
  error: string | null;
}

type PurchaseContractsAction =
  | { type: 'LOAD_START' }
  | { type: 'LOAD_SUCCESS'; payload: Pagination<IPurchaseContractResponse> }
  | { type: 'LOAD_ERROR'; payload: string };

const initialState: PurchaseContractsState = {
  contracts: new Pagination<IPurchaseContractResponse>(),
  loading: false,
  error: null,
};

const PurchaseContractsStateContext = createContext<PurchaseContractsState | undefined>(undefined);
const PurchaseContractsDispatchContext = createContext<React.Dispatch<PurchaseContractsAction> | undefined>(undefined);

function purchaseContractsReducer(state: PurchaseContractsState, action: PurchaseContractsAction): PurchaseContractsState {
  switch (action.type) {
    case 'LOAD_START':
      return { ...state, loading: true, error: null };
    case 'LOAD_SUCCESS':
      return { ...state, loading: false, contracts: action.payload };
    case 'LOAD_ERROR':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export function PurchaseContractsProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(purchaseContractsReducer, initialState);

  return (
    <PurchaseContractsStateContext.Provider value={state}>
      <PurchaseContractsDispatchContext.Provider value={dispatch}>
        {children}
      </PurchaseContractsDispatchContext.Provider>
    </PurchaseContractsStateContext.Provider>
  );
}

export function usePurchaseContractsState() {
  const context = useContext(PurchaseContractsStateContext);
  if (context === undefined) {
    throw new Error('usePurchaseContractsState must be used within a PurchaseContractsProvider');
  }
  return context;
}

export function usePurchaseContractsDispatch() {
  const context = useContext(PurchaseContractsDispatchContext);
  if (context === undefined) {
    throw new Error('usePurchaseContractsDispatch must be used within a PurchaseContractsProvider');
  }
  return context;
}
